//src/admin/features/clients/viewClientDetails/servicesClientTab/index.tsx
import SubscribedServicesCard from 'app/features/services/SubscribedServicesCard';
import { useLazyGetSubscribedServicesItemsQuery } from 'app/services/payments/orders';
import { useGetServicesQuery } from 'app/services/payments/services';
import { ISubscribedServicesItems } from 'app/services/responseTypes';
import { Filters, RadioGroup } from 'Components/Filters';
import PaginatedList from 'Components/Pagination/PaginatedList';
import usePagination from 'Components/Pagination/usePagination';
import { useParams } from 'react-router-dom';

export default function ServicesClientTab() {
  const { clientId } = useParams();

  const {
    totalCount,
    setFilters,
    Pagination,
    data,
    filters,
    refetchAfterDelete,
  } = usePagination(useLazyGetSubscribedServicesItemsQuery, {
    per_page: 3,
    filters: {
      client_id: Number(clientId),
      product_type: 'service',
    },
  });

  return (
    <div className="p-4">
      <div className="pt-1 flex justify-between items-center">
        <div className="text-gray-dark font-extrabold text-regular">
          Client's Subscribed Services
        </div>
        <div>
          <ServicesListFilters
            value={{
              state: filters.state,
              service_id: filters.service_id,
            }}
            onChange={(values) => {
              setFilters({
                ...filters,
                ...values,
              });
            }}
          />
        </div>
      </div>

      <PaginatedList
        Pagination={Pagination}
        data={data}
        renderItem={(service: ISubscribedServicesItems) => {
          return (
            <SubscribedServicesCard
              service={service}
              onDelete={refetchAfterDelete}
            />
          );
        }}
      />
    </div>
  );
}
export const serviceStatusOptions = [
  { label: 'Paid', value: 'paid' },
  { label: 'Pending Payment', value: 'pending_payment' },
  { label: 'Cancelled', value: 'cancelled' },
];
export function ServicesListFilters<
  Filters extends {
    state: string | undefined;
    service_id: number | undefined;
  },
>({ value, onChange }: { value: Filters; onChange: (f: Filters) => void }) {
  const { data: services } = useGetServicesQuery();

  return (
    <Filters
      isLoading={!services}
      preExpanded={['state']}
      value={value}
      onConfirm={onChange}
    >
      {({ updateField, state }) => (
        <>
          <RadioGroup
            label="Service Type"
            name="state"
            checked={state.state}
            options={serviceStatusOptions}
            onUpdateField={updateField}
          />
          <RadioGroup
            label="Service and Bundles"
            name="service_id"
            checked={state.service_id}
            options={(services || [])?.map((_) => ({
              value: _.id,
              label: _.title,
            }))}
            onUpdateField={updateField}
          />
        </>
      )}
    </Filters>
  );
}
